import * as React from "react";
const SvgCheck = (props) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 9, viewBox: "0 0 11 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 4.33333L3.76923 7L10 1", stroke: "currentColor", strokeWidth: 2 }));
export default SvgCheck;
